import React from "react"

const FormFieldTextarea = ({ domRef, fieldValue, dispatch, info, value, ...props }) => {
    const handleChange = e => {
        //console.log(e.currentTarget.value)
        dispatch({
            type: "change",
            field: info.field,
            label: value.label,
            fieldType: value.fieldType,
            value: e.currentTarget.value,
        })
    }
    return (
        <div ref={domRef} {...props}>
            <textarea
                name={info.field}
                type="text"
                value={fieldValue || ""}
                placeholder={info.entity.getChildValue(
                    value,
                    info.fieldInfo,
                    "label",
                    info.language
                )}
                onChange={handleChange}
            />
        </div>
    )
}
export default FormFieldTextarea
